import ACTIONS from 'constants/actionTypes';

interface Localization {
  interfaceLang: string | null;
  localeDictionaries: Record<string, Record<string, string>>;
}

interface AddLocalizationDictionaryAction {
  type: ACTIONS.ADD_LOCALIZATION_DICTIONARY;
  payload: {
    localeDictionaries: Record<string, Record<string, string>>;
  };
}

interface ChangeLanguageAction {
  type: ACTIONS.CHANGE_LOCALIZATION_LANGUAGE;
  payload: {
    interfaceLang: string;
  };
}

type LocalizationAction =
  | AddLocalizationDictionaryAction
  | ChangeLanguageAction;

const initialState: Localization = {
  interfaceLang: null,
  localeDictionaries: {},
};

const localization = (state = initialState, action: LocalizationAction) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.ADD_LOCALIZATION_DICTIONARY:
      return {
        ...state,
        localeDictionaries: {
          ...state.localeDictionaries,
          ...payload.localeDictionaries,
        },
      };

    case ACTIONS.CHANGE_LOCALIZATION_LANGUAGE:
      return {
        ...state,
        interfaceLang: action.payload.interfaceLang,
      };

    default:
      return state;
  }
};

export default localization;
